<template>
  <button @click="takeOutfit" class="round-button save-outfit-button mt-6 bg-white bg-opacity-75">
    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
    <!--<svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"></path></svg>-->
    <div v-if="!isMobile" class="round-button__alt-text">save outfit</div>
  </button>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import { isMobile } from 'mobile-device-detect';

  export default {
    name: "SnapshotSaveButton",
    data() {
      return {
        isMobile: isMobile,
      }
    },
    computed: {
      ...mapGetters('mannequin',[
        'poser',
        'mannequin'
      ]),
      ...mapGetters('snapshots',[
        'snapshots',
      ]),
      ...mapGetters('clothes',[
        'selectedClothes'
      ]),
      ...mapGetters([
        'renderer',
      ])
    },
    methods: {
      ...mapActions([
        'render',
      ]),
      ...mapActions('snapshots',[
        'createSnapshot',
      ]),
      takeOutfit() {

        let imgData = this.renderer.inst.domElement.toDataURL();// default is image/png

        // console.log(this.poser.inst);

        let outfit = {
          // object3D: null,// JSON.parse(JSON.stringify(this.poser.inst)),
          image: imgData,
          time: new Date(),
          title: 'Outfit',
          // mannequin: JSON.parse(JSON.stringify(this.mannequin)),
          // selectedClothes: JSON.parse(JSON.stringify(this.selectedClothes)),
        }

        this.createSnapshot(outfit);
      }
    }
  }
</script>

<style scoped>
  .save-outfit-button {
    justify-content: center;
    align-items: center;
    display: flex;
    width: 40px;
    height: 40px;
    padding: 0;
  }

</style>